<waitLoading *ngIf="!isLoaded()"></waitLoading>
<ng-container *ngIf="isLoaded()">
    <div class="container-fluid">
        <ng-container *ngIf="lotzero">
            <div class="row m-t-md">
                <div class="alert alert-info text-center col-12"> {{ colHeaders[2] | translate }}</div>
            </div>
        </ng-container>
        <div class="row m-t-md">
            <div class="col-12">
                <p-table [value]="lotsAwards" sortField="description" [responsive]="true">
                    <ng-template pTemplate="header">
                        <tr>
                            <th [style.width]="'10%'"></th>
                            <ng-container *ngIf="!lotzero">
                                <th class="text-left" [style.width]="'20%'"></th>
                                <th class="text-left" [style.width]="'70%'"></th>
                            </ng-container>
                            <ng-container *ngIf="!lotzero">
                                <th class="text-left" [style.width]="'90%'"></th>
                            </ng-container>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-lotAward>
                        <tr>
                            <td>
                                <p-radioButton name="groupname" value="{{lotAward.lotId}}" [(ngModel)]="selectesObject">
                                </p-radioButton>
                            </td>
                            <!-- si es lote ZERO no se visualiza el numero de lote y la descripción: sino que es de expediente -->
                            <ng-container *ngIf="!lotzero">
                                <td>
                                    <span class="p-column-title"></span> {{lotAward.lotId}}
                                </td>
                                <td>
                                    <span class="p-column-title"></span> {{lotAward.description}}
                                </td>
                            </ng-container>
                            <ng-container *ngIf="lotzero">
                                <td>
                                    <span class="p-column-title"></span>{{ 'DocumentsDetail.dossier' | translate}}
                                </td>
                            </ng-container>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr class="text-center">
                            <td colspan="3">{{colHeaders[3] | translate }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
    <div class="row m-t-md">
        <div class="col-12">
            <button class="btn btn-md  btn-primary float-right" (click)="close(selectesObject)">{{'General.accept' |
                translate}} </button>
        </div>
    </div>
</ng-container>